<template>
  <div v-if="selectedServiceId" class="vpd-available-accounts-panel">
    <div class="d-flex align-start justify-space-between flex-wrap mb-2">
  <span class="subtitle-1 flex-grow-1 mr-3">
    Kérjük erősítse meg, hogy melyik bankszámlájára vonatkozzon
    a számlatörténet megosztása!
  </span>

  <v-btn
    small
    color="secondary"
    class="mt-1"
    @click="toggleSelectAll"
  >
    {{ isAllSelected ? 'Összes kiválasztás törlése' : 'Összes kiválasztása' }}
  </v-btn>
</div>

    <v-list two-line>
      <template v-for="(account, index) in pagedAccounts">
      <v-list-item
        :value="account.id"
        :disabled="account.alreadyConnected"
        clickable
        @click="toggleAccount(account.id)"
        :class="{ 'active-row': selected.includes(account.id) }"
      >

        <!-- Bank icon -->
        <div class="img-container">
          <img :src="getBankMiniImgUrl(account.bank)" />
        </div>

        <!-- MAIN CONTENT (left & middle) -->
        <v-list-item-content>
          <v-list-item-title>
            {{ account.name }} - {{ account.currency }}
          </v-list-item-title>

          <v-list-item-subtitle class="text--primary">
            {{ account.headline }}
          </v-list-item-subtitle>

          <v-list-item-subtitle>
            {{ account.bban }}
          </v-list-item-subtitle>

          <span v-if="account.alreadyConnected" class="d-block d-lg-none">
            Már hozzáadva
          </span>
        </v-list-item-content>

        <!-- CHECKBOX ICON (right end) -->
        <v-list-item-action>
          <v-icon :color="selected.includes(account.id) ? 'secondary' : 'grey'">
            {{ selected.includes(account.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
          </v-icon>
        </v-list-item-action>

      </v-list-item>

      <v-divider
        v-if="index + 1 < pagedAccounts.length && $vuetify.breakpoint.mobile"
      />
    </template>

    <span v-if="isSelectedWithoutActiveAccount" class="subtitle-1">
      Jelenleg nincsen aktív bankszámlája!
    </span>
  
</v-list>

    <!-- Pagination Control -->
    <div class="d-flex justify-center mt-4">
      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="7"
        circle
      />
    </div>
  </div>
</template>

<script>
import "./_vpd-available-accounts-panel.scss";
import { getBankMiniImgUrl } from "@/modules/helpers";

export default {
  name: "vpd-available-accounts-panel",

  props: {
    accounts: { type: Array, required: true },
    selectedServiceId: { type: String, required: true },
    itemsPerPage: { type: Number, default: 5 },
  },

  data() {
    return {
      selected: [],
      isSelectedWithoutActiveAccount: false,
      page: 1,
    };
  },

  computed: {
    pageCount() {
      return Math.ceil(this.accounts.length / this.itemsPerPage) || 1;
    },

    pagedAccounts() {
      const start = (this.page - 1) * this.itemsPerPage;
      return this.accounts.slice(start, start + this.itemsPerPage);
    },

    isAllSelected() {
      return this.selected.length === this.accounts.length;
    },
  },

  watch: {
    selected() {
      this.isSelectedWithoutActiveAccount = this.accounts.length === 0;

      this.$emit("selected-accounts-changed", {
        length: this.selected.length,
      });
    },
  },

  methods: {
    getBankMiniImgUrl(bank) {
      return getBankMiniImgUrl(bank);
    },
    toggleAccount(id) {
      const idx = this.selected.indexOf(id);

      if (idx === -1) {
        this.selected.push(id);
      } else {
        this.selected.splice(idx, 1);
      }
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selected = [];
      } else {
        this.selected = this.accounts.map((acc) => acc.id);
      }
    },
  },
};
</script>

<style scoped>
.active-row {
  background: rgba(0, 0, 0, 0.05);
}
</style>
